import { render, staticRenderFns } from "./BookingBenefits.vue?vue&type=template&id=bfc3744c&"
import script from "./BookingBenefits.vue?vue&type=script&lang=js&"
export * from "./BookingBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports